<template>
  <RouterView />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useUserStore } from './stores/user-store'

const userStore = useUserStore()

onMounted(() => {
  // 延迟初始化用户状态，确保路由已经处理完毕
  setTimeout(() => {
    userStore.initUserState()
  }, 100)
})
</script>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
